import * as tslib_1 from "tslib";
import { CookieService } from 'ngx-cookie-service';
import { AbstractService } from '../abstract-service';
import { SessionStorageService } from '../web-storage';
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie-service/cookie-service/cookie.service";
import * as i2 from "../web-storage/session-storage.service";
var AppSessionCheckService = /** @class */ (function (_super) {
    tslib_1.__extends(AppSessionCheckService, _super);
    function AppSessionCheckService(cookieService, sessionStorageService) {
        var _this = _super.call(this) || this;
        _this.cookieService = cookieService;
        _this.sessionStorageService = sessionStorageService;
        _this.sessionStorageKey = "globalSessionId";
        _this.referenceGlobalSessionId = "X-PruGlobalSessionID";
        return _this;
    }
    AppSessionCheckService.prototype.handleApplicationSessionIntegrity = function (dataKeysToRemove) {
        var activeSessionId = this.cookieService.get(this.referenceGlobalSessionId);
        if (!!activeSessionId) {
            var currentSessionId = this.getDataFromSessionStorage(false);
            if (activeSessionId !== currentSessionId) {
                this.removeSessionData(dataKeysToRemove);
                this.setDataToSessionStorage(activeSessionId, false);
            }
        }
    };
    AppSessionCheckService.prototype.removeSessionData = function (keys) {
        var _this = this;
        if (!keys || keys.length === 0) {
            return;
        }
        keys.forEach(function (key) { return _this.sessionStorageService.removeItem(key); });
    };
    AppSessionCheckService.ngInjectableDef = i0.defineInjectable({ factory: function AppSessionCheckService_Factory() { return new AppSessionCheckService(i0.inject(i1.CookieService), i0.inject(i2.SessionStorageService)); }, token: AppSessionCheckService, providedIn: "root" });
    return AppSessionCheckService;
}(AbstractService));
export { AppSessionCheckService };
